import React, { useState } from "react";
import Drawer from "../../../../drawer/Drawer";
import DrawerHeader from "./DrawerHeader";
import ManageArtist from "../ManageArtist";

const ManageArtistDrawer = ({
  open,
  close = () => {},
  getResponse = () => {},
  data = {},
}) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [previousSize, setPreviousSize] = useState(() => {
    return localStorage.getItem("drawer-previous-size") || "";
  });

  return (
    <Drawer
      open={open}
      onClose={(val) => {
        setSelectedTab(0);
        close(val);
      }}
      size={
        previousSize
          ? previousSize
          : [0, 1].includes(selectedTab)
          ? "xl5"
          : "xl6"
      }
      title={data?._id ? "Edit Artist" : "Add Artist"}
      subtitle="View, update and modify artist details and information bellow"
      drawerBodyClass="p-0 max-h-[calc(100%-42px)]"
      closeBtn={true}
    >
      <div className="h-full overflow-y-auto">
        <ManageArtist
          getResponse={getResponse}
          close={(val) => {
            setSelectedTab(0);
            close(val);
          }}
          data={data}
          selectedTab={selectedTab}
          setSelectedTab={(val) => {
            setPreviousSize(localStorage.getItem("drawer-previous-size") || "");
            setSelectedTab(val);
          }}
        />
      </div>
    </Drawer>
  );
};

export default ManageArtistDrawer;
